import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Modal, message } from 'antd'
import history from '../../../../history'

import { actions as leadEstimateActions } from '../../../../redux/modules/leadFunctions/leadEstimateActions'
import { actions as estimateTemplateActions } from '../../../../redux/modules/jobFunctions/estimateTemplateActions'

import EstimateForm from '../../../../components/estimate/EstimateForm'

import * as authSelectors from '../../../../selectors/auth'
import * as itemsSelectors from '../../../../selectors/items'
import * as revisionSelectors from '../../../../selectors/revision'
import * as estimatesSelectors from '../../../../selectors/estimates'

const propTypes = {
  items: PropTypes.array,
  revisions: PropTypes.array,
  templates: PropTypes.array,
  estimateItems: PropTypes.array,
  templateItems: PropTypes.array,
  loadingRevision: PropTypes.bool,
  estimateSections: PropTypes.array,
  templateSections: PropTypes.array,
  user: PropTypes.object.isRequired,

  // from container
  estimateId: PropTypes.any,
  contentData: PropTypes.object,
  leadId: PropTypes.any.isRequired,
  action: PropTypes.string.isRequired,
  changeContentData: PropTypes.func.isRequired,

  // actions
  getTemplateItems: PropTypes.func.isRequired,
  createLeadEstimate: PropTypes.func.isRequired,
  deleteLeadEstimate: PropTypes.func.isRequired,
  updateLeadEstimate: PropTypes.func.isRequired,
  getTemplateSections: PropTypes.func.isRequired,
  getLeadEstimateItems: PropTypes.func.isRequired,
  getLeadEstimateSections: PropTypes.func.isRequired
}

class AddEditFormModal extends Component {
  state = {
    wrapUpEstimate: false
  }

  handleCancel = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/estimates`)
  }

  confirmDelete = event => {
    const { leadId, estimateId, deleteLeadEstimate } = this.props

    deleteLeadEstimate({
      leadId: leadId,
      estimateId: estimateId
    })

    message.success('Record deleted.')

    history.push(`/lead/${leadId}/estimates`)
  }

  loadTemplateData = templateId => {
    const { getTemplateSections, getTemplateItems } = this.props
    getTemplateSections(templateId)
    getTemplateItems(templateId)
  }

  loadEstimateData = estimateId => {
    const { getLeadEstimateSections, getLeadEstimateItems } = this.props
    getLeadEstimateSections(estimateId)
    getLeadEstimateItems(estimateId)
  }

  handleFireWrapUpEstimate = (fire = true) => {
    this.setState({
      wrapUpEstimate: fire
    })
  }

  getSelectedTemplate = value => {
    const { templates } = this.props
    const selectedTemplate = templates.find(template => template.name === value)
    return selectedTemplate ? +selectedTemplate.id : +value
  }

  handleWrapUpEstimate = estimate => {
    const { createLeadEstimate, updateLeadEstimate, user, leadId, estimateId, action } = this.props
    const estimateInfo = { ...estimate.estimateData, ...estimate.estimateTotals }

    // sanitize the selected template
    estimateInfo.estimate_template_id = this.getSelectedTemplate(estimateInfo.estimate_template_id)

    if (action === 'add' || action === 'clone') {
      createLeadEstimate({
        leadId: leadId,
        content: estimateInfo,
        estimateSections: estimate.estimateSections,
        userId: user.userId
      })
      message.success('Estimate saved.')
    } else {
      updateLeadEstimate({
        leadId: leadId,
        estimateId: estimateId,
        content: estimateInfo,
        estimateSections: estimate.estimateSections,
        userId: user.userId
      })
      message.success('Changes saved.')
    }

    this.setState(
      {
        currentId: -1,
        modalVisible: false,
        contentData: null,
        wrapUpEstimate: false,
        cloningMode: false
      },
      () => {
        history.push(`/lead/${leadId}/estimates`)
      }
    )
  }

  handleOkButton = () => {
    const { action } = this.props

    if (action === 'add') {
      return 'Create'
    } else if (action === 'edit') {
      return 'Edit'
    } else if (action === 'clone') {
      return 'Clone'
    }
  }

  render() {
    const {
      items,
      action,
      templates,
      revisions,
      estimateId,
      contentData,
      templateItems,
      estimateItems,
      loadingRevision,
      estimateSections,
      templateSections,
      changeContentData
    } = this.props

    const { wrapUpEstimate } = this.state

    return (
      <Modal
        visible={true}
        title={action === 'clone' ? 'CLONING Estimate' : 'Estimate'}
        width="98%"
        onCancel={this.handleCancel}
        okText={this.handleOkButton()}
        onOk={() => this.handleFireWrapUpEstimate(true)}
        maskClosable={false}
      >
        <EstimateForm
          items={items}
          templates={templates}
          revisions={revisions}
          currentId={estimateId}
          apiPath={'lead/estimates'}
          estimateInfo={contentData}
          templateItems={templateItems}
          estimateItems={estimateItems}
          wrapUpEstimate={wrapUpEstimate}
          handleCancel={this.handleCancel}
          handleDelete={this.confirmDelete}
          loadingRevision={loadingRevision}
          templateSections={templateSections}
          estimateSections={estimateSections}
          loadTemplateData={this.loadTemplateData}
          loadEstimateData={this.loadEstimateData}
          changeContentData={changeContentData}
          cloningMode={action === 'clone' ? true : false}
          handleWrapUpEstimate={this.handleWrapUpEstimate}
          handleFireWrapUpEstimate={this.handleFireWrapUpEstimate}
        />
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({
  user: authSelectors.getUser(state, props),
  items: itemsSelectors.getItems(state, props),
  revisions: revisionSelectors.getRevisions(state, props),
  templates: estimatesSelectors.getTemplates(state, props),
  templateItems: estimatesSelectors.getTemplateItems(state, props),
  estimateItems: estimatesSelectors.getEstimateItems(state, props),
  loadingRevision: revisionSelectors.getRevisionsLoading(state, props),
  estimateSections: estimatesSelectors.getEstimateSections(state, props),
  templateSections: estimatesSelectors.getTemplateSections(state, props)
})

const mapDispatchToProps = (dispatch, props) => ({
  deleteLeadEstimate: ({ leadId, estimateId }) =>
    dispatch(leadEstimateActions.deleteLeadEstimate({ leadId, estimateId })),
  getTemplateSections: templateId =>
    dispatch(estimateTemplateActions.getTemplateSections(templateId)),
  getTemplateItems: templateId => dispatch(estimateTemplateActions.getTemplateItems(templateId)),
  getLeadEstimateSections: estimateId =>
    dispatch(leadEstimateActions.getLeadEstimateSections(estimateId)),
  getLeadEstimateItems: estimateId =>
    dispatch(leadEstimateActions.getLeadEstimateItems(estimateId)),
  createLeadEstimate: ({ leadId, content, estimateSections, userId }) =>
    dispatch(leadEstimateActions.createLeadEstimate({ leadId, content, estimateSections, userId })),
  updateLeadEstimate: ({ leadId, estimateId, content, estimateSections, userId }) =>
    dispatch(
      leadEstimateActions.updateLeadEstimate({
        leadId,
        estimateId,
        content,
        estimateSections,
        userId
      })
    )
})

AddEditFormModal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddEditFormModal))



// WEBPACK FOOTER //
// ./src/pages/lead/components/estimates/AddEditFormModal.component.js